import {
  GET_TRACKINGS,
  GET_TRACKINGS_SUCCESS,
  GET_TRACKINGS_ERROR,
  GET_TRACKING,
  GET_TRACKING_SUCCESS,
  GET_TRACKING_ERROR,
  ADD_TRACKING,
  ADD_TRACKING_SUCCESS,
  ADD_TRACKING_ERROR,
  EDIT_TRACKING,
  EDIT_TRACKING_SUCCESS,
  EDIT_TRACKING_ERROR,
  DELETE_TRACKING,
  DELETE_TRACKING_SUCCESS,
  DELETE_TRACKING_ERROR,
  SEARCH_TRACKINGS,
  SEARCH_TRACKINGS_SUCCESS,
  SEARCH_TRACKINGS_ERROR,
  RESET_TRACKING_FLAG,
  SAVE_TRACKING_KEYWORD,
  SET_TRACKING_PAGE,
  SET_TRACKING_TOTAL_PAGE,
  RESET_TRACKING_DATA,
} from "./actionTypes"

export const getTrackings = (page = 1, keyword = "") => {
  return {
    type: GET_TRACKINGS,
    payload: { page, keyword }
  }
}

export const getTrackingsSuccess = trackings => {
  return {
    type: GET_TRACKINGS_SUCCESS,
    payload: { trackings },
  }
}

export const getTrackingsError = error => {
  return {
    type: GET_TRACKINGS_ERROR,
    payload: error,
  }
}

export const getTracking = (uid, bookingNo = "", containerNo = "") => {
  return {
    type: GET_TRACKING,
    payload: { uid, bookingNo, containerNo },
  }
}

export const getTrackingSuccess = tracking => {
  return {
    type: GET_TRACKING_SUCCESS,
    payload: { tracking },
  }
}

export const getTrackingError = error => {
  return {
    type: GET_TRACKING_ERROR,
    payload: error,
  }
}

export const addTracking = tracking => {
  return {
    type: ADD_TRACKING,
    payload: { tracking },
  }
}

export const addTrackingSuccess = message => {
  return {
    type: ADD_TRACKING_SUCCESS,
    payload: message,
  }
}

export const addTrackingError = error => {
  return {
    type: ADD_TRACKING_ERROR,
    payload: error,
  }
}

export const editTracking = tracking => {
  return {
    type: EDIT_TRACKING,
    payload: { tracking },
  }
}

export const editTrackingSuccess = message => {
  return {
    type: EDIT_TRACKING_SUCCESS,
    payload: message,
  }
}

export const editTrackingError = error => {
  return {
    type: EDIT_TRACKING_ERROR,
    payload: error,
  }
}

export const deleteTracking = tracking => {
  return {
    type: DELETE_TRACKING,
    payload: { tracking },
  }
}

export const deleteTrackingSuccess = message => {
  return {
    type: DELETE_TRACKING_SUCCESS,
    payload: message,
  }
}

export const deleteTrackingError = error => {
  return {
    type: DELETE_TRACKING_ERROR,
    payload: error,
  }
}

export const saveTrackingKeyword = keyword => {
  return {
    type: SAVE_TRACKING_KEYWORD,
    payload: keyword,
  }
}

export const setTrackingPage = page => {
  return {
    type: SET_TRACKING_PAGE,
    payload: page,
  }
}

export const setTrackingTotalPage = totalPage => {
  return {
    type: SET_TRACKING_TOTAL_PAGE,
    payload: totalPage,
  }
}

export const resetTrackingFlag = () => {
  return {
    type: RESET_TRACKING_FLAG,
  }
}

export const resetTrackingData = () => {
  return {
    type: RESET_TRACKING_DATA,
  }
}
